type QueryParams = Record<string, string | number | boolean | undefined | null>

// Builds a query string ('?a=1&b=2') from params, skipping undefined/null/'' and
// URL-encoding keys and values. Returns '' when nothing is set.
export function buildQuery (params: QueryParams): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue
    search.append(key, String(value))
  }
  const query = search.toString()
  return query ? `?${query}` : ''
}

type AsyncFn = (...args: any[]) => Promise<any>
type Context = { promise?: Promise<any>, result?: any }

export function getAsyncDataOnce (asyncFn: AsyncFn) {
  const ctx: Context = {}
  return {
    clear: () => {
      delete ctx.result
    },
    call: (...args: any[]) => {
      if (ctx.promise) return ctx.promise
      else if (ctx.result) return Promise.resolve(ctx.result)
      else {
        return ctx.promise = asyncFn(...args)
          .then((data) => {
            ctx.result = data
            return data
          })
          .catch((err) => {
            console.error(err)
            return err
          }).finally(() => {
            delete ctx.promise
          })
      }
    }
  }
}

export const getTokens = getAsyncDataOnce(
  () => fetch(`${process.env.REACT_APP_OAUTH_BASE}/auth/user/v1/token`, {
    headers: {
      accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  }).then((res) => {
    return res.json()
  })
)
